/* eslint-disable @typescript-eslint/no-explicit-any */

import { User } from "next-auth";

export default function IsAdmin(user?: User): boolean {
  return (user as any)?.isAdmin === true;
}
